import type { AppLanguage } from 'src/types';

import { getLanguagePrefixedPath } from './getLanguage';

export const displayError = (language: AppLanguage, message: string): void => {
  const pathname = `/oauth/error?state=${message}`;
  const errorUrl = getLanguagePrefixedPath(language, pathname);
  window.location.assign(errorUrl);
};
